import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getAllCadresRequest: ['response'],
    getAllCadresSuccess: ['response', 'loading'],
    getAllCadresFailure: ['error'],
})

export const getAllCadresTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const getAllCadresSuccess = (state, { response }) =>
    state.merge({
        error: false,
        response,
        loading: false,
    })
const getAllCadresFailure = (state, { error }) =>
    state.merge({
        loading: false,
        error,
    })
const getAllCadresRequest = state =>
    state.merge({ loading: true, error: null })

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_ALL_CADRES_REQUEST]: getAllCadresRequest,
    [Types.GET_ALL_CADRES_SUCCESS]: getAllCadresSuccess,
    [Types.GET_ALL_CADRES_FAILURE]: getAllCadresFailure,
})
